import { http } from '@/http/axios.js'
// 分类树
export function getGoodsCategoryTreeAPI(params) {
  return http({
    url: '/api/store/goods/category/tree',
    method: 'get',
    params
  })
}
// 新增分类
export function addGoodsCategoryAPI(data) {
  return http({
    url: '/api/store/goods/category/add',
    method: 'post',
    data
  })
}
// 编辑分类
export function editGoodsCategoryAPI(data) {
  return http({
    url: '/api/store/goods/category/edit',
    method: 'post',
    data
  })
}
// 详情
export function getGoodsCategoryDetailAPI(id) {
  return http({
    url: '/api/store/goods/category/detail',
    method: 'get',
    params: { id }
  })
}

// 删除
export function deleteGoodsCategoryAPI(id) {
  return http({
    url: '/api/store/goods/category/del',
    method: 'post',
    data: { id }
  })
}
